const problemsByStageValidation = {
  ONROUTE: {
    STOP_NOT_STARTED: true,
  },
  PENDING: {
    STOP_POSSIBLE_DELAY: true,
    STOP_LATE: true,
  },
  DONE: {
    STOP_STANDSTILL: true,
  },
};

const showProblemOutStage = ['STOP_NOT_STARTED'];
const problemsPriorityList = ['STOP_NOT_STARTED', 'STOP_STANDSTILL', 'STOP_LATE'];

const possibleProblemsPriorityList = ['STOP_POSSIBLE_DELAY'];

const sortProblems = (prioList) => (a, b) => {
  return prioList.indexOf(a) - prioList.indexOf(b);
};

const getProblem = (stage, problems = {}, { score, stageScore, priorityList }) => {
  const isOutStage = score < stageScore - 1;

  const currentProblem = Object.keys(problems)
    .filter((problem) => priorityList.includes(problem))
    .filter((problem) => !!problems[problem])
    .sort(sortProblems(priorityList))[0];

  if (!currentProblem) {
    return '';
  }

  if (isOutStage && !showProblemOutStage.includes(currentProblem)) {
    return '';
  }

  const currentProblemIsForStage = !!problemsByStageValidation[stage][currentProblem];

  return currentProblemIsForStage ? currentProblem : '';
};

const getCurrentProblem = (stage, problems, { score, stageScore }) => {
  return getProblem(stage, problems, { score, stageScore, priorityList: problemsPriorityList });
};

const getCurrentPossibleProblem = (stage, problems, { score, stageScore }) => {
  return getProblem(stage, problems, {
    score,
    stageScore,
    priorityList: possibleProblemsPriorityList,
  });
};

export { getCurrentProblem, getCurrentPossibleProblem };
